// Helper function to handle 401 unauthorized responses
export const handleUnauthorized = () => {
    // Clear stored tokens
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    sessionStorage.removeItem('access_token');
    sessionStorage.removeItem('refresh_token');

    // Navigate to login page
    window.location.href = '/login';
};

// Helper function to check response status and handle 401
export const checkResponseStatus = (response) => {
    if (response.status === 401) {
        handleUnauthorized();
        throw new Error('Unauthorized - redirecting to login');
    }
    return response;
};
